import { useSyncExternalStore } from 'react';

/**
 * Selecao das telas (Formacao, Simulador) para o contexto do copiloto. Fica FORA da URL: so ids e o texto digitado do
 * praticado (nunca resultado calculado). Cada tela publica a sua chave e limpa ao desmontar.
 */

type Filtros = Record<string, string>;

const porTela = new Map<string, Filtros>();
const ouvintes = new Set<() => void>();
let fotografia: Filtros = {};

function recalcular(): void {
  const junto: Filtros = {};
  for (const f of porTela.values()) Object.assign(junto, f);
  if (JSON.stringify(junto) === JSON.stringify(fotografia)) return;
  fotografia = junto;
  for (const o of ouvintes) o();
}

/** Retira os vazios: valor vazio nao vai para o copiloto. */
function naoVazios(filtros: Record<string, string | undefined>): Filtros {
  const saida: Filtros = {};
  for (const [chave, valor] of Object.entries(filtros)) {
    if (typeof valor === 'string' && valor.trim() !== '') saida[chave] = valor;
  }
  return saida;
}

/** Publica a selecao da tela (chave = nome da tela). Valores vazios sao descartados; sem nada, equivale a limpar. */
export function definirFiltrosTela(chave: string, filtros: Record<string, string | undefined>): void {
  const limpos = naoVazios(filtros);
  if (Object.keys(limpos).length === 0) porTela.delete(chave);
  else porTela.set(chave, limpos);
  recalcular();
}

/** Retira a selecao da tela (ao desmontar). */
export function limparFiltrosTela(chave: string): void {
  if (!porTela.has(chave)) return;
  porTela.delete(chave);
  recalcular();
}

/** Instantanea atual (mesma referencia enquanto nada mudar). */
export function obterFiltrosTela(): Filtros {
  return fotografia;
}

function assinar(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}

/** Selecao publicada pelas telas, reativa (useSyncExternalStore). */
export function useFiltrosTela(): Filtros {
  return useSyncExternalStore(assinar, obterFiltrosTela, obterFiltrosTela);
}
